import React from 'react';

import Grid from '@gogame/ui/Grid';
import Typography from '@gogame/ui/Typography';
import { SentryContext } from './SentryContext';
import captureError from './captureError';

export class SidePageErrorBoundary extends React.Component {
  static contextType = SentryContext;
  constructor(props) {
    super(props);
    this.props = props;
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    captureError(error, { cause: 'SidePage error' });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Grid
          container
          direction={'column'}
          fullHeight
          style={this.props.padding ? { padding: '20px' } : {}}
        >
          <Typography color={'error'} variant={'subtitle2'}>
            {`SidePageErrorBoundary: SidePage catch ${this.state.error.name}: ${this.state.error.message}`}
          </Typography>
        </Grid>
      );
    }

    return this.props.children;
  }
}
